import type { LedgerEntry } from './types';

export const MAX_TITLE = 60;

export const balance = (ledger: LedgerEntry[]): number =>
  ledger.reduce((sum, e) => sum + e.amount, 0);

/* Guards the Friday button: an allowance is paid at most once per week. */
export const paidForWeek = (ledger: LedgerEntry[], weekKey: string): boolean =>
  ledger.some((e) => e.kind === 'allowance' && e.week === weekKey);

/* Newest first; ties broken by insertion order so same-second entries stay stable. */
export const newestFirst = (ledger: LedgerEntry[]): LedgerEntry[] =>
  [...ledger].sort((a, b) => b.ts - a.ts);

export interface LedgerRow extends LedgerEntry {
  before: number;
  after: number;
}

/* Newest first, each row carrying the balance either side of it. The running
   total is accumulated oldest-first so every row's `after` equals the balance
   as it stood at that moment, then reversed for display. */
export const withRunningBalance = (ledger: LedgerEntry[]): LedgerRow[] => {
  let running = 0;
  const rows = [...ledger]
    .sort((a, b) => a.ts - b.ts)
    .map((e) => {
      const before = running;
      running += e.amount;
      return { ...e, before, after: running };
    });
  return rows.reverse();
};

export const makeId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
